"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const SelectPlayerRow_vue_1 = require("@/client/components/SelectPlayerRow.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectPlayer',
    props: {
        players: {
            type: Array,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedPlayer: undefined,
        };
    },
    components: {
        SelectPlayerRow: SelectPlayerRow_vue_1.default,
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selectedPlayer === undefined) {
                return;
            }
            this.onsave({ type: 'player', player: this.selectedPlayer });
        },
    },
});
